import { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'

type AvailabilityRangeProps = {
  startDate: string
  endDate: string
  style?: CSSProperties
}

const AvailabilityRange = ({
  startDate,
  endDate,
  style,
}: AvailabilityRangeProps) => {
  const { i18n } = useTranslation()

  const format = new Intl.DateTimeFormat(i18n.resolvedLanguage, {
    day: '2-digit',
    month: 'short',
  })

  if (startDate == null || endDate == null) {
    return null
  }

  const display = format.formatRange(new Date(startDate), new Date(endDate))

  return <span style={style}>{display}</span>
}

export default AvailabilityRange
